import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TermsOfUse from "../pages/terms/page";
import PrivacyPolicy from "../pages/privacy/page";
import HVACTraining from "../pages/hvac-training/page";
import ApplianceRepair from "../pages/appliance-repair/page";
import Plumbing from "../pages/plumbing/page";
import ElectricalWork from "../pages/electrical-work/page";
import WIOAProgram from "../pages/wioa-program/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/terms",
    element: <TermsOfUse />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/hvac-training",
    element: <HVACTraining />,
  },
  {
    path: "/appliance-repair",
    element: <ApplianceRepair />,
  },
  {
    path: "/plumbing",
    element: <Plumbing />,
  },
  {
    path: "/electrical-work",
    element: <ElectricalWork />,
  },
  {
    path: "/wioa-program",
    element: <WIOAProgram />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
